import React, { useState, useEffect } from 'react'
import { useUpdate } from '@pankod/refine-core'
import {
  PageHeader,
  Table,
  useTable,
  Typography,
  Badge,
  Tag,
  Row,
  Form,
  Space,
  Input,
  Icons,
  ShowButton,
  Spin,
  Button,
  Popconfirm,
  CreateButton,
  useModalForm,
  message,
} from '@pankod/refine-antd'
import { IQuestion } from 'interfaces'
import metaData from 'metadata/questions'
import RichTextRender from 'components/questions/rich_text_render'
import { useNavigation } from '@pankod/refine-core'
import { MarkRetired } from 'components/questions/mark_retired'
import { CreateQuestion } from 'pages/questions'
import { submitForApprovalOrReview } from 'helpers/multipleApprovalandMultipleReview'
import ReviewModal from './uploadedQuestionReviewModal'

interface Props {
  tableSourceData: any[]
  handleLoading: (state: boolean) => void
  fetchQuestions: (limit: number, currentPage: number, searchValue: string, userRole: string, userId: string, additionalFilters: any) => Promise<void>
  setLimitValue: (limitValue: number) => void
  setCurrentPageValue: (pageNumber: number) => void
  handleFilters: (filters: any) => void
  handleSearch: (searchValue: string) => void
  totalNumberOfItems: number
  limit: number
  currentPage: number
  userRole: string
  userId: string
  tableStateLoading: boolean
  searchValue: string
  additionalFilters: any
  request?: any
  user?: any
  qreviewerList?: any
  qapproverList?: any
  updatePercentage?: any
}

const MemoizedRichTextRender = React.memo(RichTextRender)
const AllQuestionList: React.FC<Props> = ({
  tableSourceData,
  handleLoading,
  fetchQuestions,
  setLimitValue,
  setCurrentPageValue,
  handleFilters,
  handleSearch,
  totalNumberOfItems,
  limit,
  currentPage,
  userRole,
  userId,
  tableStateLoading,
  searchValue,
  additionalFilters,
  request,
  user,
  qreviewerList,
  qapproverList,
  updatePercentage,
}) => {
  const { Text, Link } = Typography
  const { show } = useNavigation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [currentRecord, setCurrentRecord] = useState<any>(null)
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const { mutate: updateQuestionActiveFlag } = useUpdate()
  const handleOk = () => {
    setIsModalVisible(true)
  }
  const handleCancel = () => {
    setIsModalVisible(false)
  }
  const showModal = (id: string) => {
    setCurrentRecord(id)
    setIsModalVisible(true)
  }
  const {
    formProps: createFormProps,
    modalProps: createModalProps,
    show: createShow,
  } = useModalForm({
    resource: 'questions',
    action: 'create',
    redirect: false,
    metaData,
  })
  createModalProps.width = '100%'
  const onSelectChange = (selectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(selectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
    getCheckboxProps: (record: any) => {
      return {
        disabled:
          userRole === 'subjectincharge' &&
          additionalFilters?.topic_id &&
          additionalFilters?.question_created_through === 'Uploaded' &&
          record?.status?.trim()?.toLowerCase() === 'open'
            ? false
            : request?.id === null || request?.id === undefined
            ? true
            : (userRole === 'qcreator' || userRole === 'variantcreator') &&
              (record?.status === 'Open' || record?.status === 'Open (Require Amending)')
            ? false
            : userRole === 'qreviewer' &&
              (record?.status === 'For Review' || record?.status === 'Second Review' || record?.status === 'For Review (Require Amending)')
            ? false
            : userRole === 'qapprover' && (record?.status === 'For Approval' || record?.status === 'Second Approval')
            ? false
            : true,
      }
    },
  }
  const multipleActions = async (status: string) => {
    setLoading(true)
    const response = await submitForApprovalOrReview(status, selectedRowKeys, request, userRole, qreviewerList, user, qapproverList)
    if (response?.message) {
      message.error(response.message)
    }
    setLoading(false)
    setSelectedRowKeys([])
    await fetchQuestions(limit, currentPage, searchValue, userRole, userId, additionalFilters)
  }
  const handleFetchQuestions = async () => {
    createdQuestions++
    disableCreate = request ? createdQuestions >= request.count : false
    await fetchQuestions(limit, currentPage, searchValue, userRole, userId, additionalFilters)
  }
  const reloadPage = async () => {
    await fetchQuestions(limit, currentPage, searchValue, userRole, userId, additionalFilters)
  }
  let createdQuestions =
    request?.request_type === 'V'
      ? request?.variant_options?.reduce((sum: number, item: any) => sum + JSON.parse(item?.variant_count), 0)
      : request?.questions?.reduce((sum: number, item: any) => sum + (item.active === 'true' ? 1 : 0), 0) ?? 0
  let disableCreate = request ? createdQuestions >= request.count : false
  return (
    <>
      {request && (
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          {userRole === 'qcreator' && request && (
            <CreateButton
              disabled={disableCreate}
              key="create"
              type="primary"
              icon={<Icons.PlusOutlined />}
              onClick={() => {
                createModalProps.forceRender = true
                createFormProps.form?.resetFields()
                createShow()
              }}
              hidden={!request?.id}
            />
          )}

          {(userRole === 'qcreator' || userRole === 'variantcreator' || userRole === 'qapprover' || userRole === 'qreviewer') &&
            selectedRowKeys.length > 0 && (
              <div>
                <Popconfirm
                  title={
                    userRole === 'qapprover'
                      ? 'Are you sure, Do you want to send these items for Approval?'
                      : `Are you sure, Do you want to send these items for ${
                          userRole === 'qcreator' || userRole === 'variantcreator' ? 'review' : 'Approval'
                        }?`
                  }
                  okText="Confirm"
                  cancelText="No"
                  onCancel={() => console.log('ook')}
                  onConfirm={async () =>
                    await multipleActions(
                      userRole === 'qcreator' || userRole === 'variantcreator'
                        ? 'For Review'
                        : userRole === 'qreviewer'
                        ? 'For Approval'
                        : userRole === 'qapprover'
                        ? 'Published'
                        : ''
                    )
                  }
                >
                  <Button style={{ marginLeft: '5px' }} loading={loading} type="dashed">
                    {userRole === 'qcreator' || userRole === 'variantcreator'
                      ? 'Submit For Review'
                      : userRole === 'qapprover'
                      ? 'Submit for Publish'
                      : userRole === 'qreviewer'
                      ? 'Submit For Approval'
                      : ''}
                  </Button>
                </Popconfirm>
              </div>
            )}
        </div>
      )}

      <PageHeader>
        {userRole === 'subjectincharge' &&
          additionalFilters?.topic_id &&
          additionalFilters?.question_created_through === 'Uploaded' &&
          selectedRowKeys.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <ReviewModal selectedRowKeys={selectedRowKeys} userId={userId} reloadPage={reloadPage} />
            </div>
          )}
        <Row gutter={[24, 24]} style={{ marginLeft: '2px' }}></Row>
        <Table
          rowKey="id"
          key="table"
          bordered
          size="small"
          //showing row based selection if request is present or subject incharge role choosen added topic wise filter and uploaded questions only
          rowSelection={
            request || (userRole === 'subjectincharge' && additionalFilters?.topic_id && additionalFilters?.question_created_through === 'Uploaded')
              ? rowSelection
              : undefined
          }
          dataSource={tableSourceData}
          loading={tableStateLoading}
          scroll={{ x: 'max-content' }}
          pagination={{
            total: totalNumberOfItems,
            pageSize: limit,
            current: currentPage,
            onChange: async (page, pageSize) => {
              localStorage.setItem(`allquestions_${userId}_${userRole}_page_number`, page.toString())
              setCurrentPageValue(page)
              setLimitValue(pageSize)
              if (userId) {
                await fetchQuestions(pageSize, page, searchValue, userRole, userId, additionalFilters)
              }
            },
          }}
        >
          <Table.Column
            title="Question Id"
            key="question_id"
            dataIndex="question_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 100 }} ellipsis={{ tooltip: `${record?.username}` }}>
                  {record?.question_id}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Question"
            key="title"
            dataIndex="title"
            width={150}
            render={(_, record: any) => {
              return (
                <ShowButton
                  size="small"
                  type="link"
                  icon={null}
                  recordItemId={record?.id}
                  onClick={() => {
                    show('questions', record?.id)
                  }}
                >
                  <Text
                    style={{
                      width: 200,
                      textAlign: 'left',
                      color: '#6659FF',
                      cursor: 'pointer',
                    }}
                    ellipsis={{ tooltip: record?.title }}
                  >
                    <MemoizedRichTextRender content={record?.title} />
                  </Text>
                </ShowButton>
              )
            }}
          />
          <Table.Column
            title="Q Type"
            key="question_type_id"
            dataIndex="question_type_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 100 }} ellipsis={{ tooltip: `${record?.question_type_id}` }}>
                  {record?.question_type_id}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Request Type"
            key="request_type"
            dataIndex="request_type"
            render={(_, record: any) => {
              return (
                <Text ellipsis={{ tooltip: `${record?.request_type}` }}>
                  {record?.request_type && record?.request_type === 'Uploaded' ? 'Uploaded' : 'Created manually'}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Source"
            key="source"
            dataIndex="source"
            render={(_, record: any) => {
              return <Text ellipsis={{ tooltip: `${record?.request_type}` }}>{record?.source ? record?.source : 'N/A'}</Text>
            }}
          />
          <Table.Column
            title="Grade"
            key="grade_ids"
            dataIndex="grade_ids"
            render={(_, record: { question_grades: any[]; grade_ids: any }) => {
              const { question_grades } = record
              return question_grades?.length > 0 ? (
                <div>
                  {question_grades.length > 1 ? (
                    <Badge size="small" count={question_grades.length - 1} style={{ background: '#6659ff' }}>
                      <Tag color={'blue'} key={question_grades[0]?.grade?.name}>
                        {question_grades[0]?.grade?.name}
                      </Tag>
                    </Badge>
                  ) : (
                    <Tag color={'blue'} key={question_grades[0]?.grade?.name}>
                      {question_grades[0]?.grade?.name}
                    </Tag>
                  )}
                </div>
              ) : null
            }}
          />
          <Table.Column
            title="Status"
            key="question_type_id"
            dataIndex="status"
            render={(value, record: any) => {
              return (
                <Tag
                  color={
                    value === 'Published'
                      ? 'green'
                      : value === 'Rejected at Review' || value === 'Rejected at Approval' || value === 'Retired'
                      ? 'volcano'
                      : value === 'Open (Require Amending)' || value === 'For Review (Require Amending)'
                      ? 'pink'
                      : 'geekblue'
                  }
                >
                  {value}
                </Tag>
              )
            }}
          />
          <Table.Column
            title="Difficulty"
            key="difficulty_level_id"
            dataIndex="difficulty_level_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 150 }} ellipsis={{ tooltip: record?.difficulty_level?.name }}>
                  {record?.difficulty_level?.name}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Bloom's Level"
            key="bloom_leve_ids"
            dataIndex="bloom_leve_ids"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 150 }} ellipsis={{ tooltip: record?.bloom_level?.name }}>
                  {record?.bloom_level?.name}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Subject"
            key="subject_id"
            dataIndex="subject_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 150 }} ellipsis={{ tooltip: record?.subject?.name }}>
                  {record?.subject?.name}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Theme"
            key="theme_id"
            dataIndex="theme_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 150 }} ellipsis={{ tooltip: record?.theme?.name }}>
                  {record?.theme?.name}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Sub Theme"
            key="sub_theme_id"
            dataIndex="sub_theme_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 150 }} ellipsis={{ tooltip: record?.sub_theme?.name }}>
                  {record?.sub_theme?.name}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Topic"
            key="topic_id"
            dataIndex="topic_id"
            render={(_, record: any) => {
              return (
                <Text style={{ width: 150 }} ellipsis={{ tooltip: record?.topic?.name }}>
                  {record?.topic?.name}
                </Text>
              )
            }}
          />
          <Table.Column
            title="Actions"
            key="actions"
            dataIndex="id"
            render={(_, record: any) => {
              return (
                <>
                  {/* for make the question retaire */}
                  {userRole === 'qbincharge' && record?.status !== 'Retired' ? (
                    <Button type="primary" onClick={() => showModal(record?.id)}>
                      Mark Retired
                    </Button>
                  ) : null}
                  {userRole === 'admin' ||
                  (userRole === 'qcreator' && record?.status === 'Open') ||
                  (userRole === 'variantcreator' && record?.status === 'Open') ? (
                    <Popconfirm
                      title="Are you sure ?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={async () => {
                        await updateQuestionActiveFlag({ resource: 'questions', id: record?.id, values: { active: 'false' } })
                        await fetchQuestions(limit, currentPage, searchValue, userRole, userId, additionalFilters)
                        if (updatePercentage) {
                          createdQuestions--
                          disableCreate = request ? createdQuestions >= request.count : false
                          await updatePercentage()
                          if (selectedRowKeys.length > 0) {
                            setSelectedRowKeys(prevKeys => prevKeys.filter(key => key !== record.id))
                          }
                        }
                      }}
                      // onConfirm={(e: any) => ifConfirm(e, record.id,request)}
                    >
                      <Button
                        danger
                        size="small"
                        type="link"
                        icon={null}
                        // hidden={
                        //   (request?.request_type === 'V' && userRole === 'qcreator') || (request?.request_type === 'Q' && userRole === 'variantcreator')
                        // }
                      >
                        <Icons.DeleteOutlined />
                      </Button>
                    </Popconfirm>
                  ) : null}
                </>
              )
            }}
          />
        </Table>
      </PageHeader>
      <MarkRetired isModalVisible={isModalVisible} handleOk={handleOk} handleCancel={handleCancel} id={currentRecord} />
      {createModalProps.visible && (
        <CreateQuestion
          modalProps={createModalProps}
          formProps={createFormProps}
          request={request}
          handleFetchQuestions={handleFetchQuestions}
          updatePercentage={updatePercentage}
          // customTags={customTags}
        />
      )}
    </>
  )
}

export default AllQuestionList
